import { axios } from 'lib';
import { useAuth } from 'lib/auth';
import React, { createContext, useState, useEffect, useContext } from 'react';

export const defaultJobAdPreferences = {
  application_method: 'email',
};

const JobAdPreferencesContext = createContext();

export const JobAdPreferencesProvider = ({ children }) => {
  const { user } = useAuth();
  const [preferences, setPreferences] = useState(defaultJobAdPreferences);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getPreferences = async () => {
      if (user) {
        try {
          const { data } = await axios.get('/api/users/preferences');
          if (data && data?.jobAd) {
            setPreferences(currentPreferences => ({
              ...currentPreferences,
              ...data.jobAd,
            }));
          }
        } catch (error) {
          console.error("Failed to fetch user preferences", error);
        } finally {
          setIsLoaded(true);
        }
      } else {
        setPreferences(defaultJobAdPreferences);
        setIsLoaded(true);
      }
    }
    getPreferences();
  }, [user]);

  const updatePreferences = async (newPrefs) => {
    if (user && !user.super_admin) {
      const prefsToSave = { ...preferences, ...newPrefs };
      setPreferences(prefsToSave);
      try {
        await axios.put('/api/users/preferences', { jobAd: prefsToSave });
      } catch (error) {
        console.error("Failed to save user preferences", error);
      }
    }
  }

  const contextValue = { preferences, updatePreferences, isLoaded };

  return (
    <JobAdPreferencesContext.Provider value={contextValue}>
      {children}
    </JobAdPreferencesContext.Provider>
  );
};

export const useJobAdPreferences = () => {
  const context = useContext(JobAdPreferencesContext);
  if (context === undefined) {
    throw new Error('useJobAdPreferences must be used within a JobAdPreferencesProvider');
  }
  return context;
};
